// NavigationBlocker.jsx
import { useEffect } from 'react';
import { history } from '../history';

export default function NavigationBlocker({ when, message }) {
  useEffect(() => {
    if (!when) return; // Don't block if not needed

    // Set up the navigation block
    const unblock = history.block((tx) => {
      // Use the window.confirm or any custom modal logic here
      if (window.confirm(message)) {
        // Remove the blocker and retry the transition
        unblock();
        tx.retry();
      }
      // Else: do nothing, blocking the navigation
    });

    return () => {
      // Cleanup the block on unmount or when `when` changes
      unblock();
    };
  }, [when, message]);

  return null; // This component does not render anything visible
}
